const translations = {
  INTERNAL_SAMPLER: 'Internal',
  SOILVIEW_SAMPLER: 'SoilView',
  OTHER_SAMPLER: 'Other',
  ROGO_SAMPLER: 'Rogo',
  SURETECH_STANDARD_LABORATORY: 'SureTech - Standard (RO + Zn + S)',
  SURETECH_COMPLETE_LABORATORY: 'SureTech - Complete (C)',
  WATERS_STANDARD_LABORATORY: 'Waters',
  OTHER_LABORATORY: 'Other',
  SOIL_SAMPLE_BEFORE_PLANT: 'Before Plant',
  SOIL_SAMPLE_AFTER_PLANT: 'After Plant',
  SOIL_SAMPLE_AFTER_HARVEST: 'After Harvest',
  SOIL_SAMPLE_PRIORITY_1: 'Priority 1',
  SOIL_SAMPLE_PRIORITY_2: 'Priority 2',
  SOIL_SAMPLE_PRIORITY_3: 'Priority 3',
  SOIL_SAMPLE_PRIORITY_4: 'Priority 4',
  SOIL_SAMPLE_PRIORITY_1_form: 'Priority 1: <24 hours after harvest',
  SOIL_SAMPLE_PRIORITY_2_form: 'Priority 2: 0-5 day sampling',
  SOIL_SAMPLE_PRIORITY_3_form: 'Priority 3: 0-10 day sampling (average)',
  SOIL_SAMPLE_PRIORITY_4_form: 'Priority 4: 0-15 day sampling (no rush)',
  SOIL_SAMPLE_PRIORITY_1_form_new:
    'Urgent: <24 hours after harvest (Priority 1)',
  SOIL_SAMPLE_PRIORITY_2_form_new: 'High: 0-5 day sampling (Priority 2)',
  SOIL_SAMPLE_PRIORITY_3_form_new: 'Medium: 0-10 day sampling (Priority 3)',
  SOIL_SAMPLE_PRIORITY_4_form_new: 'Low: 0-15 day sampling (Priority 4)',
  SOIL_TARGET_SOURCE_NOT_SET: `Not Set`,
  SOIL_TARGET_SOURCE_UNKNOWN: `Unknown`,
  SOIL_TARGET_SOURCE_UNKNOWN_MANUAL: `Unknown`,
  SOIL_TARGET_SOURCE_UPLOADED: `Uploaded`,
  SOIL_TARGET_SOURCE_UPLOADED_INFO: `User uploaded sample for a blank field via the sample upload tool`,
  SOIL_TARGET_SOURCE_UPLOADED_MANUAL: `Manual - Uploaded`,
  SOIL_TARGET_SOURCE_UPLOADED_MANUAL_INFO: `Points were edited from their original locations`,
  SOIL_TARGET_SOURCE_GRID: `AA Hexagon Grid`,
  SOIL_TARGET_SOURCE_GRID_INFO: `Points were set by the system at the centroids of the hexagons`,
  SOIL_TARGET_SOURCE_GRID_MANUAL: `Manual - AA Hexagon Grid`,
  SOIL_TARGET_SOURCE_GRID_MANUAL_INFO: `Points were edited from their original locations`,
  SOIL_TARGET_SOURCE_TERRAIN: `Terrain Based`,
  SOIL_TARGET_SOURCE_TERRAIN_INFO: `Points were generated based on Terrain driven algorithm`,
  SOIL_TARGET_SOURCE_TERRAIN_MANUAL: `Manual - Terrain Based`,
  SOIL_TARGET_SOURCE_TERRAIN_MANUAL_INFO: `Points were originally created from the Terrain based algorithm, but have been user modified`,
};

export const reducers = {
  translations: (state = translations) => state,
};
